import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

export type InfringementStatus = "report_ready" | "no_report";

export interface InfringementRow {
    region_name: string;
    domain_name: string;
    paid_presence_rate?: number;
    active_days?: number;
    unique_ads?: number;
    title_only_count?: number;
    desc_only_count?: number;
    both_count?: number;
    search_terms?: string[];
    /** Paid Presence Rate of the domain on each of its search terms, in %. */
    search_term_rates?: Record<string, number | null>;
    status: InfringementStatus;
    days: number;
}

export interface InfringementExportRow {
    domain_name: string;
    region_name: string;
    url: string | null;
    url_referral: string | null;
    title: string | null;
    description: string | null;
    gcs_uri: string | null;
}

const JSON_HEADERS = {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Accept: "application/json",
};

const brandInfringement = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: "api.brandInfringement",
    tagTypes: ["brandInfringement"],
    endpoints: (builder) => ({
        // Every region at once: the page filters the rows by country itself.
        getInfringementGrid: builder.query<{ rows: InfringementRow[] }, {
            workspaceTable?: string, days: number,
        }>({
            query: (body) => ({
                url: `/visibility/brand-infringement/getInfringingDomains`,
                method: "POST",
                body: JSON.stringify(body),
                headers: JSON_HEADERS,
            }),
            providesTags: ["brandInfringement"],
        }),
        getInfringementExport: builder.query<{ rows: InfringementExportRow[] }, {
            workspaceTable?: string, country?: string | null, days: number, domain?: string,
        }>({
            query: (body) => ({
                url: `/visibility/brand-infringement/getTrademarkReportExport`,
                method: "POST",
                body: JSON.stringify(body),
                headers: JSON_HEADERS,
            }),
        }),
        exportTrademarkReport: builder.mutation<{ id: string }, {
            workspaceTable?: string, country?: string | null, days: number, domain: string,
        }>({
            query: (body) => ({
                url: `/visibility/brand-infringement/exportTrademarkReport`,
                method: "POST",
                body: JSON.stringify(body),
                headers: JSON_HEADERS,
            }),
        }),
    }),
});

export const {
    useGetInfringementGridQuery,
    useLazyGetInfringementExportQuery,
    useExportTrademarkReportMutation,
} = brandInfringement;

export default brandInfringement;
